// DEPRECATED - Use KeyNodeType
export const MasterKeyTypesList = [
  { id: 0, name: 'FutureKey' },
  { id: 1, name: 'ControlKeyMaster' },
  { id: 2, name: 'ControlKey' },
  { id: 3, name: 'ConstructionKeyMaster' },
  { id: 4, name: 'ConstructionKey' },
  { id: 5, name: 'SingleKeyDifferentMaster' },
  { id: 6, name: 'SingleKeyDifferent' },
  { id: 7, name: 'DirectChangeMaster' },
  { id: 8, name: 'Direct' },
  { id: 9, name: 'Master' },
  { id: 10, name: 'ChangeKey' },
  { id: 11, name: 'SelectiveMaster' },
  { id: 12, name: 'CrossKeyMaster' },
  { id: 13, name: 'CrossKeyChild' },
  { id: 14, name: 'OrphanMaster' },
  { id: 15, name: 'Orphan' },
  { id: 16, name: 'FutureKey' },
  { id: 99, name: 'ChangeKeyThruNode' },
  { id: 100, name: 'SingleKeyDifferentThruNode' },
]
